import { FormControl, Grid, TextField, Typography } from '@mui/material'
import React from 'react'

export default function SectionSale({FormRequestGlobal, formOpeningMode}) {

  const { formState, onInputChange, onInputChangeForNumber } = FormRequestGlobal
  return (
    <>
      <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
        Informacion de la venta
      </Typography>
      <div className="border-bottom border-dark"></div>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="costo_total">Costo Total del Vehiculo (Q)</label>
              <TextField
                  id='costo_total'
                  name='costo_total'
                  value={ formState.costo_total }
                  onChange={ onInputChange }
                  size='small'
                  placeholder='Costo de Adquisición'
                  type='text'
                  variant='filled'
                  InputProps={{
                      readOnly:  false 
                  }}
                  required
              />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="monto_venta">* Monto de Venta (Q)</label>
              <TextField
                  id='monto_venta'
                  name='monto_venta'
                  value={ formState.monto_venta }
                  onChange={ onInputChangeForNumber }
                  size='small'
                  placeholder='Monto de Venta'
                  type='text'
                  variant={(formOpeningMode)==='EDITABLE' ? 'outlined' : 'filled'}
                  InputProps={{
                    readOnly:  (formOpeningMode)==='EDITABLE' ? false : true 
                  }}
                  required
              />
          </FormControl>
        </Grid>
      </Grid>
    </>
  )
}
